import { State } from './types';
import { BOMOutput } from '@/types';

export const state: State = {
    configurations: [],
    bom: { materials: [] as BOMOutput[], totalPower: 0 },
};
